import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=fa494836&scoped=true"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./summary.vue?vue&type=style&index=1&id=fa494836&prod&scoped=true&lang=css"
import style2 from "./summary.vue?vue&type=style&index=2&id=fa494836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa494836",
  null
  
)

export default component.exports